import { useEffect, useMemo, useState } from "react";
import $ from "jquery";
import image8 from "assets/hm_service_image/MHSD_footer.png";
import changeimg from "assets/hm_service_image/changes.png";
import image9 from "assets/hm_service_image/MHSDmb.png";
import image10 from "assets/hm_service_image/footer-introduce-step.png";
import { checkInventorySD, getDetailPreOrderHashcode, getStatusPreorderSD, loginSD, updatePreOrder } from "services/pre-order.service";
import { CAPACITYS, COLORS, PRODUCTS } from "config/products";
import HomeBannerPromotion from "components/shared/HomeBannerPromotion";
import { HomeStyled } from "styles/homeStyled";
import { notification, Modal } from "antd";
import { useHistory, useParams } from "react-router-dom/cjs/react-router-dom.min";
import { formatPrice, getCookie, getWarehouse } from "utils/helpers";
import { CheckCircleFilled } from "@ant-design/icons";
import tag from "assets/hm_service_image/tag/san-hang-16.png";
import { SDPassword, SDUserName } from "utils/contants";
import homebn from "assets/hm_service_image/bn-wait.png";

function ChangeProduct() {
    const history = useHistory();
    const [loading, setLoading] = useState(true);
    const [preOrder, setPreOrder] = useState({});
    const { pre_order_id } = useParams();
    const [responseSandBox, setResponseResSandBox] = useState([]);
    const [changeLocked, setChangeLocked] = useState(false);
    const [loadingProducts, setLoadingProducts] = useState(true);
    const [checkStatus, setCheckStatus] = useState(false);

    // 1. Lấy preorder
    useEffect(() => {
        const getData = async () => {
            const res = await getDetailPreOrderHashcode(pre_order_id);
            if (!res?.data) return res;

            let product = PRODUCTS.find((x) => +x.productId === +res.data.PRODUCTID);
            if (product) {
                res.data.productSelect = { ...product };
            }
            return res;
        };

        const loadPreOrder = async () => {
            setLoading(true);
            try {
                const res = await getData();
                if (res?.data) setPreOrder(res.data);
            } catch (error) {
                notification.error({
                    message: error?.message ?? "Không có dữ liệu đơn hàng",
                });
            } finally {
                setLoading(false);
            }
        };

        loadPreOrder();
    }, [pre_order_id]);

    // 2. Check status preorder (chỉ khi có token + preOrder)
    useEffect(() => {
        const getDataCheckStatus = async () => {
            const res = await getStatusPreorderSD(preOrder?.ORDERNO);
            if (res) setCheckStatus(res?.data);
        };

        if (preOrder?.ORDERNO) {
            getDataCheckStatus();
        }
    }, [preOrder?.ORDERNO]);

    // 3. Login ShopDunk (chỉ khi có preOrder)
    useEffect(() => {
        const loginShopDunk = async () => {
            const storage = getWarehouse(preOrder?.STORENAME);
            const data = {
                listProductCode: [
                    "MJRP4X/A",
                    "MJRQ4X/A",
                    "MJRR4X/A",
                    "MJRT4X/A",
                    "MJRU4X/A",
                    "MJRV4X/A",
                    "MJRW4X/A",
                    "MJRX4X/A",
                    "MJRY4X/A",
                    "MJT04X/A",
                    "MJT14X/A",
                    "MJT24X/A",
                    "MJT34X/A",
                    "MJT44X/A",
                    "MJT54X/A",
                    "MJT64X/A",
                    "MJXN4X/A",
                    "MJXP4X/A",
                    "MJXQ4X/A",
                    "MJXR4X/A",
                    "MJXT4X/A",
                    "MJXU4X/A",
                    "MJXV4X/A",
                    "MJXW4X/A",
                    "MJXX4X/A",
                    "MJXY4X/A",
                    "MJY04X/A",
                    "MJY14X/A",
                    "MJY24X/A",
                    "MJY34X/A",
                    "MJY44X/A",
                    "MJY54X/A",
                ],
                listBranchCode: [],
                listWarehouseCode: [storage],
            };
            setLoadingProducts(true)
            const res = await checkInventorySD(data);
            if (res) {
                setResponseResSandBox(res?.data?.data || []);
                setLoadingProducts(false);
            }
        };

        if (preOrder?.STORENAME) {
            loginShopDunk();
        }
    }, [preOrder?.STORENAME]);

    // 4. Lọc sp còn tồn
    const endProduct = PRODUCTS.filter(product => {
        return responseSandBox?.some(sandboxItem =>
            sandboxItem.productCode === product.productCode &&
            sandboxItem.isInventory === true &&
            sandboxItem.totalInventory > 0
        );
    });

    // 5. Group theo modelId
    const groupedProducts = useMemo(() => {
        const map = new Map();

        endProduct.forEach((product) => {
            if (!map.has(product.modelId)) {
                map.set(product.modelId, []);
            }
            map.get(product.modelId).push(product);
        });
        return Array.from(map.entries());
    }, [endProduct]);

    return (
        <HomeStyled>
            <div className="pre-order-page">
                <div className="page pre-home-page">
                    <div className="home-banner home-banner-rp">
                        <div className="content-home-banner bn-big">
                            {/* <img src={homebn} alt="" width="100%" className="" /> */}
                            {/* <img src={homebnmb} alt="" width="100%" className="f-mb" /> */}
                            <HomeBannerPromotion />
                        </div>
                    </div>

                    {/* <div className="container-ordercomplete">
                        <h3>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M4.03498 11.573C4.49698 9.264 4.72798 8.11 5.55698 7.43C6.38698 6.75 7.56398 6.75 9.91898 6.75H14.081C16.436 6.75 17.613 6.75 18.442 7.43C19.272 8.11 19.502 9.264 19.965 11.573L20.565 14.573C21.229 17.893 21.561 19.553 20.661 20.652C19.761 21.75 18.067 21.75 14.681 21.75H9.31998C5.93398 21.75 4.23998 21.75 3.33998 20.652C2.43998 19.554 2.77198 17.894 3.43598 14.573L4.03498 11.573Z" fill="#049844" />
                                <path d="M15 10.75C15.5523 10.75 16 10.3023 16 9.75C16 9.19772 15.5523 8.75 15 8.75C14.4477 8.75 14 9.19772 14 9.75C14 10.3023 14.4477 10.75 15 10.75Z" fill="#5EBF23" />
                                <path d="M9 10.75C9.55228 10.75 10 10.3023 10 9.75C10 9.19772 9.55228 8.75 9 8.75C8.44772 8.75 8 9.19772 8 9.75C8 10.3023 8.44772 10.75 9 10.75Z" fill="#5EBF23" />
                                <path d="M9.75 5.75C9.75 5.15326 9.98705 4.58097 10.409 4.15901C10.831 3.73705 11.4033 3.5 12 3.5C12.5967 3.5 13.169 3.73705 13.591 4.15901C14.0129 4.58097 14.25 5.15326 14.25 5.75V6.75H14.681C15.058 6.75 15.414 6.75 15.75 6.752V5.75C15.75 4.75544 15.3549 3.80161 14.6517 3.09835C13.9484 2.39509 12.9946 2 12 2C11.0054 2 10.0516 2.39509 9.34835 3.09835C8.64509 3.80161 8.25 4.75544 8.25 5.75V6.752C8.586 6.75 8.942 6.75 9.319 6.75H9.75V5.75Z" fill="#5EBF23" />
                            </svg>
                            Thông tin đặt hàng
                        </h3>
                        <div className="info-ordercomplete">
                            <InformationCommon preOrder={preOrder} />
                            <div className="products">
                                <ul>
                                    <li>
                                        <strong>Sản phẩm: </strong>
                                        <span>{preOrder?.productSelect?.productName}</span>
                                    </li>
                                    {preOrder.ATTRIBUTES?.map((attr, index) => (
                                        <li key={index}>
                                            <strong>{attr.ATTRIBUTENAME}:</strong> {attr.ATTRIBUTEVALUES}
                                        </li>
                                    ))}
                                    <li><strong>Số lượng: </strong>1</li>
                                </ul>
                            </div>
                        </div>
                    </div> */}

                    <div className="head-change">
                        <h3 className="title-change">Chọn sản phẩm bạn muốn đổi</h3>
                        <img className="icon-change" src={changeimg} alt="" />
                    </div>

                    {loadingProducts ? (
                        <div className="loading-wrapper" style={{ textAlign: "center", padding: "40px 0" }}>
                            <span className="loading-text">Đang tải sản phẩm...</span>
                            <div className="spinner" style={{ marginTop: 16 }}>
                                <svg
                                    width="40"
                                    height="40"
                                    viewBox="0 0 40 40"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    style={{ animation: "spin 1s linear infinite" }}
                                >
                                    <circle
                                        cx="20"
                                        cy="20"
                                        r="18"
                                        stroke="#1890ff"
                                        strokeWidth="4"
                                        strokeLinecap="round"
                                        strokeDasharray="90"
                                        strokeDashoffset="60"
                                    />
                                </svg>
                            </div>
                        </div>
                    ) : endProduct.length > 0 ? (
                        <div className="section-productchange">
                            {groupedProducts.map(([modelId, products]) => (
                                <ModelOptions
                                    key={modelId}
                                    products={products}
                                    pre_order_id={pre_order_id}
                                    preOrder={preOrder}
                                    changeLocked={changeLocked}
                                    onChanged={() => setChangeLocked(true)}
                                    checkStatus={checkStatus}
                                />
                            ))}
                        </div>
                    ) : (
                        <p style={{ textAlign: "center", margin: "20px 0", fontSize: "16px", color: "white" }}>
                            Hiện tại chưa có sản phẩm nào khả dụng để đổi.
                        </p>
                    )}

                    <div className="footer-introduce desktop">
                        <img src={image8} alt="" width="100%" />
                    </div>

                    <div className="footer-introduce mobile">
                        <h3 className="tt-introduce">Tại sao nên mua hàng tại ShopDunk</h3>
                        <div className="d-scroll">
                            <img src={image9} alt="" width="1328px" />
                        </div>
                        {/* <h3 className="tt-introduce">Cách sở hữu iPhone 16 Pro Max sớm nhất, giá tốt nhất</h3>
                        <div className="d-scroll">
                            <img src={image10} alt="" width="1032px" />
                        </div> */}
                    </div>
                </div>
            </div>
        </HomeStyled>
    );
}

function ModelOptions({ products, preOrder, changeLocked, onChanged, checkStatus }) {
    const [selectedCapacity, setSelectedCapacity] = useState(products[0]?.capacityKey);
    const [selectedColor, setSelectedColor] = useState(products[0]?.colorKey);
    const [loading, setLoading] = useState(false);
    const [delayLoaded, setDelayLoaded] = useState(false);
    const capacities = [...new Set(products.map((p) => p.capacityKey))];
    const filteredByCapacity = products.filter((p) => p.capacityKey === selectedCapacity);
    const colors = [...new Set(filteredByCapacity.map((p) => p.colorKey))];
    const [isChanged, setIsChanged] = useState(false);
    const createdDate = new Date(preOrder?.CREATEDDATE);
    const startOfSep2026 = new Date('2026-08-01T00:00:00');

    const isBeforeSep2026 = createdDate < startOfSep2026;

    useEffect(() => {
        if (!colors.includes(selectedColor)) {
            setSelectedColor(colors[0]);
        }
    }, [selectedCapacity, products]);

    useEffect(() => {
        const timer = setTimeout(() => setDelayLoaded(true), 1000);
        return () => clearTimeout(timer);
    }, []);

    const selectedProduct = products.find(
        (p) => p.capacityKey === selectedCapacity && p.colorKey === selectedColor
    );

    const handleSubmit = async () => {
        if (!selectedProduct) {
            notification.error({ message: "Vui lòng chọn sản phẩm cần đổi" });
            return;
        }
        setLoading(true);
        try {
            const token = await loginSD({
                userId: 1,
                username: SDUserName,
                password: SDPassword
            });

            if (token?.access_token) {
                const res = await updatePreOrder(
                    Number(preOrder.PREORDERID),
                    Number(selectedProduct.productId),
                    token?.access_token
                );

                // notification.success({ message: "Đổi sản phẩm thành công!" });

                Modal.success({
                    icon: null,
                    title: (
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                            <CheckCircleFilled style={{ color: "#52c41a", fontSize: 20 }} />
                            <span>Đổi sản phẩm thành công</span>
                        </div>
                    ),
                    closable: true,
                    okText: "Đóng",
                    maskStyle: { backgroundColor: "rgba(0,0,0,0.75)" },
                    width: 500,
                    content: (
                        <div style={{ marginTop: 12 }}>
                            <p>Bạn đã đổi sang sản phẩm:</p>
                            <div style={{ display: "flex", alignItems: "center", gap: 12, marginTop: 8 }}>
                                <img
                                    src={selectedProduct.imageUrl}
                                    alt={selectedProduct.productName}
                                    width={80}
                                    style={{ borderRadius: 8, border: "1px solid #eee", padding: "4px" }}
                                />
                                <div>
                                    <h4 style={{ margin: 0 }}>{selectedProduct.productName}</h4>
                                    {/* <p style={{ margin: 0, color: "#555" }}>
                                {formatPrice(selectedProduct.price, true)}
                            </p> */}
                                    {/* ✅ thêm dung lượng + màu */}
                                    <p style={{ margin: 0, fontSize: 13 }}>
                                        Dung lượng: <strong>{selectedProduct.capacityKey}</strong>
                                    </p>
                                    <p style={{ margin: 0, fontSize: 13 }}>
                                        Màu: <strong>{selectedProduct.colorName}</strong>
                                    </p>
                                </div>

                            </div>
                            <div className="content-success">
                                <p>ShopDunk xin cảm ơn quý khách đã tin tưởng lựa chọn.</p>
                                <p>Chúng tôi sẽ gửi thông tin xác nhận qua ZNS or SMS. </p>
                                <p>Trân trọng !!!</p>
                            </div>
                        </div>
                    ),
                    // onOk: () => {
                    //     // tuỳ logic, ví dụ reload lại trang hoặc redirect
                    //     // window.location.reload();
                    // },
                });
            } else {
                notification.error({ message: "Token không hợp lệ." });
            }

            setIsChanged(true);
            onChanged?.();
        } catch (error) {
            notification.error({
                message: "Đổi sản phẩm thất bại",
                description: error?.response?.data?.message || error.message,
            });
        } finally {
            setLoading(false);
        }
    };


    const disabledAll = loading || changeLocked;
    return (
        <section className="section-content-productchange">
            <div className="tag-img">
                <img src={tag} alt="" width="100%" />
            </div>
            {selectedProduct && (
                <div className="selected-product">
                    <img src={selectedProduct.imageUrl} alt={selectedProduct.productName} width={200} />
                </div>
            )}

            {/* Chọn dung lượng */}
            <div className="capacity-options">
                {capacities.map((cap) => {
                    const capName =
                        CAPACITYS.find((c) => c.capacityKey === cap)?.name || cap;
                    return (
                        <span
                            key={cap}
                            className={`capacity-btn ${cap === selectedCapacity ? "active" : ""}`}
                            onClick={() => {
                                if (cap !== selectedCapacity) {
                                    setSelectedCapacity(cap); // chỉ update khi khác
                                }
                            }}
                        >
                            {capName}
                        </span>
                    );
                })}
            </div>

            {/* Chọn màu */}
            <div className="color-options">
                {colors.map((color) => {
                    const colorItem = COLORS.find((c) => c.colorKey === color);
                    return (
                        <span
                            key={color}
                            className={`attribute-square ${color === selectedColor ? "active" : ""}`}
                            onClick={() => setSelectedColor(color)}
                            title={colorItem?.colorName}
                            style={{
                                backgroundColor: colorItem?.colorKey,
                                display: "inline-block",
                                width: "28px",
                                height: "28px",
                                borderRadius: "100%",
                                boxShadow: "inset 1px 1px 2px rgb(0 0 0 / 10%)",
                                cursor: "pointer",
                            }}
                        ></span>
                    );
                })}
            </div>

            {!isBeforeSep2026 &&
                <div>
                    <h2>{products[0]?.productName}</h2>
                    {selectedProduct && (
                        <p className="product-price">{formatPrice(selectedProduct.price, true)}</p>
                    )}

                    {
                        !changeLocked
                        && checkStatus?.isReplaced === false
                        && checkStatus?.isAssignedToBatch === false
                        && checkStatus?.isRefunded === false
                        && checkStatus?.isConfirmedWait === false
                        && checkStatus?.isPaid === true
                        && checkStatus?.isDelivered === false
                        && (
                            <button
                                className={`btn-change ${disabledAll ? "is-disabled" : ""}`}
                                onClick={handleSubmit}
                                disabled={disabledAll}
                            >
                                {loading
                                    ? "Đang đổi..."
                                    : !delayLoaded
                                        ? "Đang tải..."
                                        : "Đổi ngay"}
                            </button>
                        )
                    }
                </div>
            }
        </section>
    );
}

export default ChangeProduct;
